import { render, staticRenderFns } from "./penalty-record.vue?vue&type=template&id=124931c1&"
import script from "./penalty-record.vue?vue&type=script&lang=ts&"
export * from "./penalty-record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports